export const DownTriangle = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={5} fill="none">
        <path
            fill="#FF6B6B"
            fillRule="evenodd"
            d="M.96.61A.583.583 0 0 1 1.5.25h7a.583.583 0 0 1 .412.996l-3.5 3.5a.583.583 0 0 1-.825 0l-3.5-3.5A.583.583 0 0 1 .961.61Zm1.948.807L5 3.508l2.092-2.091H2.908Z"
            clipRule="evenodd"
        />
    </svg>
);
